module.exports = __webpack_public_path__ + "static/media/Orkos_Siopis_11.eacba3ca.jpg";